// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Upload = function Upload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.663 2.15A.93.93 0 0 0 10 1.876a.93.93 0 0 0-.662.276L4.49 7.084a.845.845 0 0 0 .038 1.23.937.937 0 0 0 1.284-.037L9.09 4.94v7.672c0 .482.406.87.91.87.503 0 .908-.388.908-.87V4.94l3.275 3.333a.934.934 0 0 0 1.284.037.845.845 0 0 0 .037-1.23L10.66 2.147zM3.639 16.385c-.503 0-.909.388-.909.87 0 .483.406.871.91.871H16.36c.504 0 .909-.388.909-.87 0-.483-.405-.871-.909-.871z"
  }));
};
